// apps/client/src/client/services/payment/use-payment-stats.ts

import { useQuery } from "@tanstack/react-query";
import { axios } from "@/client/libs/axios";
import qs from "qs";

export interface PaymentStats {
  total: number;
  pending: number;
  buyed: number;
  canceled: number;
  totalAmount: number;
  averageAmount: number;
}

export const fetchPaymentStats = async (from?: Date, to?: Date): Promise<PaymentStats> => {
  const params = { from: from?.toISOString(), to: to?.toISOString() };
  const response = await axios.get<PaymentStats>("/payments/stats", {
    params,
    paramsSerializer: (p) => qs.stringify(p, { skipNulls: true }),
  });
  return response.data;
};

export const usePaymentStats = (from?: Date, to?: Date) => {
  return useQuery({
    queryKey: ["paymentStats", from, to],
    queryFn: () => fetchPaymentStats(from, to),
  });
};

export interface RevenueByRate {
  rateId: string;
  rateName: string;
  total: number;
  count: number;
}

export const fetchPaymentRevenueByRate = async (
  from?: Date,
  to?: Date,
): Promise<RevenueByRate[]> => {
  const params = { from: from?.toISOString(), to: to?.toISOString() };
  const response = await axios.get<RevenueByRate[]>("/payments/revenue-by-rate", {
    params,
    paramsSerializer: (p) => qs.stringify(p, { skipNulls: true }),
  });
  return response.data;
};

export const usePaymentRevenueByRate = (from?: Date, to?: Date) => {
  return useQuery({
    queryKey: ["paymentRevenueByRate", from, to],
    queryFn: () => fetchPaymentRevenueByRate(from, to),
  });
};
